export default "__VITE_ASSET__BN4Y2gEL__"